/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Condensed/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2AppointmentIcon from 'DesignSystem/Svgs/Tysiav2AppointmentIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Condensed({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/LowerSection/AppointmentCount/Condensed"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let calendarAppointmentCountValueData = fromData.useDataValue({ viewPath,
context: 'calendar',
path: 'appointment_count',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Condensed.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-1lf7MX': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Condensed.Vertical"
  data-view-path={viewPath}
 style={{'--pb-2-1lf7MX': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2AppointmentIcon
  viewPath={`${viewPath}/Tysiav2AppointmentIcon`}
 width={16}
 height={16}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="calendar.appointment_count"
 text={calendarAppointmentCountValueData}
 color={dtColorsNeutral900}
 size="small"
 weight="medium"
/>
</div>
{children}
</React.Fragment>)
}